import {
  animate, stagger, onScroll,
} from 'animejs';

// Categories Grid
(() => {
  const categorySource = document.querySelector('.category-section-2');
  if (!categorySource) return;

  const quicklinks = categorySource.querySelector('.quicklinks');
  const title = quicklinks?.querySelector(':scope > h4.title');
  const rootLink = categorySource.querySelector('.root-link');

  /** CMS navigation titles may include intentional HTML (e.g. spans, line breaks). */
  const mountHtmlFromString = (heading, htmlString) => {
    const staging = document.createElement('div');
    staging.innerHTML = htmlString;
    heading.replaceChildren(...[...staging.childNodes].map((node) => node.cloneNode(true)));
  };

  const renderTitleHtml = (heading) => {
    const decoder = document.createElement('textarea');
    decoder.innerHTML = heading.innerHTML;
    const decoded = decoder.value;

    // Same as assigning heading.innerHTML = decoded — parses entity-encoded markup (&lt;span&gt;).
    mountHtmlFromString(heading, decoded);

    if (!heading.querySelector('*') && heading.textContent.includes('<')) {
      mountHtmlFromString(heading, heading.textContent.trim());
    }
  };

  if (title) renderTitleHtml(title);
  if (quicklinks && (title || rootLink)) {
    const titleWrapper = document.createElement('div');
    titleWrapper.classList.add('category-section-2__title-wrapper');
    const insertBefore = title || rootLink;
    insertBefore.before(titleWrapper);
    if (title) titleWrapper.append(title);
    if (rootLink) {
      rootLink.classList.remove('root-link');
      rootLink.classList.add('btn-custom', 'secondary');
      titleWrapper.append(rootLink);
    }
  }

  const enhanceItem = (item) => {
    const topAnchor = item.querySelector('a');
    if (!topAnchor) return;
    if (!topAnchor.nextElementSibling) return;
    const shopNowItem = document.createElement('li');
    shopNowItem.classList.add('shop-now');
    const cloneAnchor = topAnchor.cloneNode(true);
    cloneAnchor.textContent = 'Shop Now';
    shopNowItem.append(cloneAnchor);
    topAnchor.nextElementSibling.append(shopNowItem);

    const catBgImage = item.querySelector('.cat-bg-img img');
    if (!catBgImage) return;
    const imageWrapper = document.createElement('div');
    imageWrapper.classList.add('image-wrapper');
    const presentationImage = document.createElement('img');
    presentationImage.src = catBgImage.src;
    presentationImage.alt = '';
    presentationImage.setAttribute('aria-hidden', 'true');
    presentationImage.setAttribute('role', 'presentation');
    imageWrapper.append(presentationImage);
    topAnchor.before(imageWrapper);
  };

  const grid = document.createElement('div');
  grid.classList.add('category-section-2__grid');

  const categories = categorySource.querySelectorAll('.hasSubmenus > li');
  categories.forEach((category) => {
    const gridItem = document.createElement('div');
    gridItem.classList.add('category-section-2__item');
    gridItem.innerHTML = category.innerHTML;
    enhanceItem(gridItem);
    grid.appendChild(gridItem);
  });

  if (!quicklinks) return;
  quicklinks.insertAdjacentElement('beforeend', grid);
})();

/**
 * Animate
 */
(() => {
  document.querySelectorAll('.animate.category-section-2 .category-section-2__grid').forEach((section) => {
    if (!section.children.length) return;
    animate(Array.from(section.children), {
      y: ['120px', 0],
      opacity: [0, 1],
      duration: 1700,
      delay: stagger(900),
      autoplay: onScroll({
        target: section,
        enter: 'bottom center',
        leave: 'bottom-=420 center',
        sync: 0.3,
        debug: false,
      }),
    });
  });
})();
